import helper from '@/libs/forms';

export default {
  schema: {
    fields: [
      helper.simpleInput(
        'number',
        'Number of flips in last 12 months',
        '',
        'flipsLastYear',
        true,
        6,
      ),
      helper.simpleInput(
        'number',
        'Number of flips in last 3 years',
        '',
        'flipsLastThreeYear',
        true,
        6,
      ),
      helper.simpleInput(
        'number',
        'Planned flips in next 12 months',
        '',
        'flipsNextYear',
        true,
        6,
      ),
      helper.simpleInput(
        'number',
        'Number of flips lifetime',
        '',
        'flipsLifetime',
        true,
        6,
      ),
      helper.simpleInput(
        'number',
        'Number of construction flips lifetime',
        '',
        'flipsConstructionLifetime',
        true,
        6,
      ),
      helper.simpleInput(
        'number',
        'Number of construction flips last 3 years',
        '',
        'flipsConstructionLastThreeYears',
        true,
        6,
      ),
      helper.simpleInput(
        'number',
        'Number of construction flips last 24 Months',
        '',
        'flipsConstructionLastTwoYears',
        true,
        6,
      ),
    ],
  },
  options: helper.options('real-estate-', true),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/real_estate/schemas/schema.js